import { CookieGroups } from '../../../common/oneTrust/oneTrustTypes';

const DARK_FILTER_CLASS_NAME = 'onetrust-banner-dark-filter';

/**
 * Add a cookie banner overlay element, that will span the page, and prevent users
 * from interacting with page before interacting with banner
 */
export const addCookieBannerPageOverlay = (): void => {
    const darkFilter = document.createElement('div');
    darkFilter.classList.add(DARK_FILTER_CLASS_NAME);

    document.body.append(darkFilter);
};

export const removeCookieBannerPageOverlay = (): void => {
    const darkFilters = document.getElementsByClassName(DARK_FILTER_CLASS_NAME);
    Array.from(darkFilters).forEach((darkFilter) => document.body.removeChild(darkFilter));
};

/**
 * Check whether a specific cookie group is allowed
 *
 * @param cookieGroupId Cookie category to check
 * @returns {boolean|null}
 */
export const cookieGroupAllowed = (cookieGroupId: CookieGroups): boolean | null => {
    if (!window.OnetrustActiveGroups) return null;

    return window.OnetrustActiveGroups.includes(cookieGroupId);
};

/**
 * Get the consent status for all cookie groups as a map.
 * Returns null if OnetrustActiveGroups is not available.
 */
export const getConsentSettings = (): Record<CookieGroups, boolean> | null => {
    const activeGroups = window.OnetrustActiveGroups;
    if (!activeGroups) return null;

    return Object.values(CookieGroups).reduce<Record<CookieGroups, boolean>>(
        (acc, group) => {
            acc[group] = activeGroups.includes(group);
            return acc;
        },
        {
            [CookieGroups.STRICTLY_NECESSARY_COOKIES]: false,
            [CookieGroups.FUNCTIONAL_COOKIES]: false,
            [CookieGroups.PERFORMANCE_COOKIES]: false,
            [CookieGroups.TARGETING_COOKIES]: false,
        },
    );
};
